import { GetPageByRouteQuery } from "@eurodrive/apollo"
import { BlockRenderer } from "@eurodrive/ui"
import { getBreadCrumbs, transformProperties } from "@eurodrive/utils"

type Props = {
  data: GetPageByRouteQuery
  locale: string
}

const components = {
  heroBannerInnerPages: () => import("@eurodrive/ui/Banner"),
  calculatorContent: () => import("@eurodrive/ui/CalculatorContent"),
}

export default function Calculator({ data, locale }: Props) {
  const parsedData = data?.page?.properties || []
  const { blocks } = transformProperties(parsedData)
  const breadCrumbs = getBreadCrumbs(data, locale)
  return (
    <>
      {blocks?.blocks?.map((block: any, index: number) => {
        let blockProps = {}
        if (block.blockType === "heroBannerInnerPages") {
          blockProps = { breadCrumbs }
        }
        return (
          <BlockRenderer
            key={index}
            blockType={block.blockType}
            blockData={block}
            components={components}
            locale={locale}
            props={blockProps}
          />
        )
      })}
    </>
  )
}
